module.exports = __webpack_public_path__ + "static/img/liucheng.1bbd4c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/app/liucheng.png
// module id = Tqa9
// module chunks = 69